import React, { useState } from "react";
import SuccessMsg from "../Extra/SuccessMsg";
import FailedMsg from "../Extra/FailedMsg";

const defaultOptions = {
  role: ["Admin", "User", "dataEntry"],
  desg: ["Officer", "Supervisor", "Staff"],
  dept: ["TRD", "Operating", "Engineering", "S&T", "TRO", "Commercial"],
  stn: ["Station A", "Station B", "Station C"],
};
const fullForm = {
  name: "Name",
  username: "Username",
  password: "Password",
  role: "Role",
  desg: "Designation",
  dept: "Department",
  stn: "Station",
};

const AddNewUser = () => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const [show, setShow] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    username: "",
    password: "",
    role: "",
    desg: "",
    dept: "",
    stn: "",
  });

  const insertData = async (allData) => {
    setLoading(true);

    try {
      const response = await fetch(`${urlPrefix}register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(allData),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      setResult(result);
      setShow(true);
      setLoading(false);
    } catch (error) {
      console.error("Error submitting data:", error);
      // Optional: throw or return error
      setLoading(false);
      setShow(true);
    }
  };

  const handleChange = (field) => (e) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    for (const key in formData) {
      if (formData[key] === "") {
        setShow(true);
        setErrorMsg(`Please fill data at ${key}`);
        return; // Stop further execution
      }
    }

    // All fields filled
    setErrorMsg(""); // clear error
    insertData(formData);
  };

  return (
    <div className="container">
      <div
        className="papaDivDark"
        style={{ background: "rgba(0,0,0,0)", color: "white" }}
      >
        <div className="">
          <table
            className="table table-bordered text-center"
            style={{ background: "rgba(0,0,0,0)" }}
          >
            <tbody>
              {/* Text Inputs */}
              {["name", "username", "password"].map((field) => (
                <tr key={field}>
                  <th
                    className="text-capitalize align-middle"
                    style={{ background: "rgba(0,0,0,0)", color: "white" }}
                  >
                    {fullForm[field]}
                  </th>
                  <td style={{ background: "rgba(0,0,0,0)", color: "white" }}>
                    <input
                      style={{ background: "rgba(0,0,0,0)", color: "white" }}
                      type={field === "password" ? "password" : "text"}
                      value={formData[field]}
                      onChange={handleChange(field)}
                      placeholder={`enter ${field}`}
                      className="form-control transparent-input"
                      required
                    />
                  </td>
                </tr>
              ))}

              {/* Dropdown + Custom Input Fields */}
              {["role", "desg", "dept", "stn"].map((field) => (
                <tr key={field}>
                  <th
                    className="text-capitalize align-middle"
                    style={{ background: "rgba(0,0,0,0)", color: "white" }}
                  >
                    {fullForm[field]}
                  </th>
                  <td style={{ background: "rgba(0,0,0,0)", color: "white" }}>
                    <select
                      style={{ background: "rgba(0,0,0,0)", color: "white" }}
                      className="form-select mb-2"
                      onChange={(e) =>
                        setFormData({ ...formData, [field]: e.target.value })
                      }
                      value={
                        defaultOptions[field].includes(formData[field])
                          ? formData[field]
                          : ""
                      }
                    >
                      <option value="" style={{ color: "white" }}>
                        -- Select {field} --
                      </option>
                      {defaultOptions[field].map((option) => (
                        <option
                          key={option}
                          value={option}
                          style={{
                            background: "rgba(0,0,0,0)",
                            color: "black",
                          }}
                        >
                          {option}
                        </option>
                      ))}
                    </select>
                    <input
                      style={{ background: "rgba(0,0,0,0)", color: "white" }}
                      type="text"
                      placeholder={`Or enter custom ${field}`}
                      value={
                        !defaultOptions[field].includes(formData[field])
                          ? formData[field]
                          : ""
                      }
                      onChange={handleChange(field)}
                      className="form-control transparent-input"
                    />
                  </td>
                </tr>
              ))}

              {/* Submit Button Row */}
              <tr>
                <td
                  colSpan="2"
                  style={{
                    background: "rgba(0,0,0,0)",
                    color: "black",
                  }}
                >
                  <div className="row ps-5 pe-5">
                    <button
                      className="btn btn-outline-success  "
                      onClick={handleSubmit}
                    >
                      Submit
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="p-3">
        {result && result.status === "ok" ? (
          <SuccessMsg
            head="Success"
            message={result.message}
            show={show}
            setShow={setShow}
          />
        ) : (
          result && (
            <FailedMsg
              head="Failed"
              message={result.message || "Failed to complete the task"}
              show={show}
              setShow={setShow}
            />
          )
        )}
        {errorMsg && (
          <FailedMsg
            head="Failed"
            message={errorMsg}
            show={show}
            setShow={setShow}
          />
        )}
      </div>
    </div>
  );
};
export default AddNewUser;
